import React from 'react'
import { Field, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { defaultTo } from 'ramda'
import DatePickerField from 'components/form/datepicker'
import withFieldError from 'components/form/with-error'
import moment from 'moment'

const selector = formValueSelector('widget')
const DatePickerFieldWithError = withFieldError(DatePickerField)

const validateBlastDate = (blastDate, { endDate: widgetExpiry }) => {
  if (blastDate >= widgetExpiry) {
    return 'Blast date cannot be after widget expiry date'
  }

  if (blastDate <= moment.now()) {
    return 'Blast date cannot be in the past'
  }
}

const TimeStampComponent = ({ name, executedAt, widgetExpiry }) => {
  return !executedAt ? (
    <div className='row'>
      <div className='col-sm-6'>
        <Field
          component={DatePickerFieldWithError}
          name={`${name}.data`}
          format={defaultTo(new Date().valueOf())}
          validate={validateBlastDate}
          normalize={defaultTo(new Date().valueOf())}
        />
      </div>
      <div className='col-sm-6'>
        <label>
          <span className='labelRight'>
            Send within
            <Field
              component='input'
              type='number'
              format={defaultTo(60)}
              name={`${name}.expiration`}
              min={1}
              className='form-control smallField center'
            />
            minutes
          </span>
        </label>
      </div>
    </div>
  ) : (
    <div className='row'>
      <div className='col-sm-6'>
        <span className='has-error-text'>
          Blast already executed at {new Date(executedAt).toString()}
        </span>
      </div>
    </div>
  )
}

TimeStampComponent.propTypes = {
  name: PropTypes.string,
  executedAt: PropTypes.number,
  widgetExpiry: PropTypes.number
}

const TimeStampComponentWithActions = connect((state, props) => ({
  executedAt: selector(state, `${props.name}.executedAt`),
  widgetExpiry: selector(state, `endDate`)
}))(TimeStampComponent)

export default TimeStampComponentWithActions



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/triggers/common-triggers/send-at-specific-time/index.js